import { Button, Checkbox, Tabs } from "antd";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";
import FiltersForm from "../../components/FiltersForm/FiltersForm";
import Icon from "../../components/Icon/Icon";
import ArchivedTab from "./ArchivedTab/ArchivedTab";
import styles from "./BackofficeFeedbackList.module.scss";
import FeedbackTab from "./FeedbackTab/FeedbackTab";
import SpamTab from "./SpamTab/SpamTab";
import { useBackofficeFeedbackList } from "./useBackofficeFeedbackList";

const BackofficeFeedbackList = () => {
	const {
		filterDefaultValues,
		filterFields,
		getFiltersAsQueryParams,
		onChangeViewMyFeedbacksOnly,
		onResetFilters,
		onSubmitFilters,
		state,
		toggleMobileFilters } = useBackofficeFeedbackList();
	
	const { activeFilters, showMobileFilters } = state;

	const location: any = useLocation();
	const { activeTab } = location.state || {};

	const { TabPane } = Tabs;

	const tabBarExtraContent = {
		right: (
			<div className={styles.tabBarExtraContent}>
				<Checkbox className={styles.checkbox} onChange={onChangeViewMyFeedbacksOnly}><FormattedMessage id="formLabels.viewMyFeedbacksOnly" /></Checkbox>
			</div>
		)
	};

	return <div className={styles.pageContainer}>
		<div className={`${styles.pageSider} ${styles.topBorder}`}>
      <FiltersForm
        fields={filterFields}
        defaultValues={filterDefaultValues}
        onResetFilters={onResetFilters}
        onSubmit={(filters) => onSubmitFilters(filters)} />
    </div>
    <div className={styles.pageContent}>
			<div className={styles.mobileTopper}>
        <Button type="text" onClick={toggleMobileFilters} icon={<Icon color="black" name="sliders-h" />} />
      </div>
			<div className={styles.tabBarExtraContentMobile}>
				<Checkbox className={styles.checkbox} onChange={onChangeViewMyFeedbacksOnly}><FormattedMessage id="formLabels.viewMyFeedbacksOnly" /></Checkbox>
			</div>
      <Tabs
        className={`navigator ${styles.content}`}
				defaultActiveKey={activeTab?.toString() || "1"}
				tabBarExtraContent={tabBarExtraContent}
				destroyInactiveTabPane
			>
				<TabPane
					key="1"
					tab={<>
					<span className={styles.tabNav}>
            <FormattedMessage id="navigation.feedback" />
					</span>
            <span className={styles.tabDivider}>/</span>
          </>}
				>
					<FeedbackTab filters={getFiltersAsQueryParams(activeFilters)}/>
				</TabPane>
				<TabPane
					key="2"
					tab={<>
					<span className={styles.tabNav}>
            <FormattedMessage id="navigation.archived" />
					</span>
            <span className={styles.tabDivider}>/</span>
          </>}
				>
					<ArchivedTab filters={getFiltersAsQueryParams(activeFilters)}/>
				</TabPane>
				<TabPane
					key="3"
					tab={<>
					<span className={styles.tabNav}>
            <FormattedMessage id="navigation.spam" />
					</span>
          </>}
				>
					<SpamTab filters={getFiltersAsQueryParams(activeFilters)}/>
				</TabPane>
       
      </Tabs>
    </div>

    {/* Mobile filters */}
			<div className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''}`}></div>
			<div className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''}`}>
				<div className={styles.actions}>
					<Button onClick={toggleMobileFilters} type="link" style={{paddingRight: 0}}>
						<Icon
							color="text"
							height="16px"
							name="times"
							width="16px"
						/>
					</Button>
				</div>
				<FiltersForm
					fields={filterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={() => onResetFilters(toggleMobileFilters)}
					onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)} />
			</div>
  </div>
	
}
export default BackofficeFeedbackList;